import type { ReactNode } from "react";
import { Grid } from "@mui/material";
import Competence from "constants/Competence";
import type { TransfertCEA, PerimetreSansTerritoire } from "models";
import { withComponentErrorBoundary } from "utils/errorHandling";
import PerimetreSansTerritoireEauAssGepuSousCompetences from "./PerimetreSansTerritoireEauAssGepuSousCompetences";
import InformationsError from "components/Errors/InformationsError";

interface PerimetrePorteesInformationsProps {
  perimetre: PerimetreSansTerritoire;
  transferts: Array<TransfertCEA>;
}

function PerimetreSansTerritoirePorteesInformations({
  perimetre,
  transferts,
}: Readonly<PerimetrePorteesInformationsProps>): ReactNode {
  switch (perimetre.competence) {
    case Competence.EAU:
    case Competence.ASS:
      return (
        <Grid container spacing={2} size={12}>
          <PerimetreSansTerritoireEauAssGepuSousCompetences transferts={transferts} />
        </Grid>
      );
    case Competence.GCE:
    case Competence.GEPU:
      return (
        <InformationsError title="Cette fonctionnalité n'a pour l'instant pas été développée" />
      );

    default:
      return null;
  }
}

const PerimetreSansTerritoirePorteesInformationsWithErrorBoundary = withComponentErrorBoundary(
  PerimetreSansTerritoirePorteesInformations
);

export default PerimetreSansTerritoirePorteesInformationsWithErrorBoundary;
